<template>
  <div
    class="dark:text-white flex justify-between w-full items-center sticky top-0 bg-white z-[10] pb-3 border-b dark:bg-dark-blue"
  >
    <span class="text-base font-[500] uppercase">
      <slot name="title"></slot>
    </span>
    <div class="border border-gray-300 p-2 shadow rounded">
      <slot name="svg"></slot>
    </div>
  </div>
</template>
